import React, {Component} from "react";
import { connect } from 'react-redux'

import MaterialTable from 'material-table';

var courseService = require ('../api');
 

class CourseEvaluationBrief extends Component {

    constructor(props) {
        super(props);
        
        this.state = {
          brief : [],
          evaluations: [] 
        }
    }

    findEval ( ev, calif ) {
        let tmp =  ev.res?.find( su => ( su.short_name === calif &&  su.evaluation_id === ev.evaluation_id))?.qty;
        if (tmp===undefined) tmp = 0;
        return tmp;
    }
    pct ( valor, total ) {
        let p = ( valor / total ) * 100;
        return Math.round(p,2);
    }
    componentDidMount() {
            courseService.getCourseSubjectsEvalsBrief( this.props.token, this.props.courseID  )
            .then( json => {
                this.setState( {evaluations: json.evaluations});

                let dev = [];
                json.subjects.map( (subj) => {
                    let row = {} ;
                    row.long_name = subj.long_name;

                    // Loop entre las evaluaciones
                    subj.evaluations.map( (ev) => {
                        let tea = this.findEval(ev, 'TEA');
                        let tep = this.findEval(ev, 'TEP');
                        let ted = this.findEval(ev, 'TED');
                        let tot = tea+ted+tep;

                        row["tea".concat(ev.evaluation_id )] = tea;
                        row["tep".concat(ev.evaluation_id )] = tep;
                        row["ted".concat(ev.evaluation_id )] = ted;
 
                        row["tot".concat(ev.evaluation_id )] = tot < this.props.qty? 'Incompleto' : ( tot > this.props.qty? 'Verif' : '' ) ;
 
                        // Saco los porcentajes para no empastar el reporte
                        row["tea".concat(ev.evaluation_id )] = ''.concat(tea, ' (',this.pct(tea,tot),'%)');
                        row["tep".concat(ev.evaluation_id )] = ''.concat(tep, ' (',this.pct(tep,tot),'%)');
                        row["ted".concat(ev.evaluation_id )] = ''.concat(ted, ' (',this.pct(ted,tot),'%)');
                        return null;
                    } ) ;

                     dev.push(row)
                     return null;
                })

                this.setState( { brief: dev } );
            } )


    }

 
      render() {
            let cols = [ { width: '70%', title: 'Área', field: 'long_name' } ];

            this.state.evaluations.map( (ev, idx) => {
                cols.push({ title: 'TEA '.concat(ev.short_name), field: 'tea'.concat(ev.evaluation_id ), type: 'numeric',
                    headerStyle: { backgroundColor: (idx%2===0?'#efefef':'#ffffff') },
                    cellStyle: { backgroundColor: (idx%2===0?'#efefef':'#ffffff') }
                }) ;
                cols.push({ title: 'TEP '.concat(ev.short_name), field: 'tep'.concat(ev.evaluation_id ), type: 'numeric',
                headerStyle: { backgroundColor: (idx%2===0?'#efefef':'#ffffff') },
                cellStyle: { backgroundColor: (idx%2===0?'#efefef':'#ffffff') }
             }) ;
                cols.push({ title: 'TED '.concat(ev.short_name), field: 'ted'.concat(ev.evaluation_id ), type: 'numeric',
                headerStyle: { backgroundColor: (idx%2===0?'#efefef':'#ffffff') },
                cellStyle: { backgroundColor: (idx%2===0?'#efefef':'#ffffff') }
             }) ;

             cols.push({ title: '', field: 'tot'.concat(ev.evaluation_id ), 
             headerStyle: { backgroundColor: (idx%2===0?'#efefef':'#ffffff') },
             cellStyle: { backgroundColor: (idx%2===0?'#efefef':'#ffffff') }
          }) ;
          return null;

            } ) ;
 
            return (
                <>
                    <MaterialTable
                        title={this.props.title.concat(' - Total ',this.props.qty,' alumnos')}
                        columns={cols}
                        data={ this.state.brief }        
                        options={{
                            exportButton: true,
                            search: false,
                            paging: false
                        }}
                        localization={{
                            toolbar: {
                              exportCSVName: "Exportar CSV",
                              exportPDFName: "Exportar PDF"
                            }
                          }}
                    />
                </>
            );
        }   
  }
  
  const mapStateToProps = state => {
    return {
        token: state.auth.session.jwt_token,
    }
  }

  const mapDispatchToProps = dispatch => {
    return { 
        // getSchoolCourse: (token, courseID, calendarID) => {
        //   dispatch(courseActions.getSchoolCourse(token, courseID, calendarID));
        // } ,
    }
    }

    export default connect(mapStateToProps, mapDispatchToProps)(CourseEvaluationBrief);


